import React, { ReactElement } from 'react';
import { Row, Col, Empty } from 'antd';

const NoDataFound = (): ReactElement => {
  return (
    <Row style={{ width: '100%' }}>
      <Col md={24}>
        {/* <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} /> */}
        <Empty />
      </Col>
    </Row>
  );
};

export default NoDataFound;
